/****
 * Root application component that initializes authentication,
 * application theme, and routing during startup.
 */
import "./i18n/i18n";
import "./index.css";

import { type JSX, useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";

import { router } from "./app/router";
import { useGlobalAuthSync } from "./hooks/useGlobalAuthSync";
import { initTheme } from "./store/theme";

export default function App(): JSX.Element {
  useGlobalAuthSync();
  const dispatch = useDispatch();

  /**
   * Initialize theme ONCE when app loads.
   * This safely applies:
   * - theme1
   * - theme2
   */
  useEffect(() => {
    dispatch<any>(initTheme());
  }, [dispatch]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}
